import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from './base-query';

const vehicleModelAPI = createApi({
    reducerPath: "vehicleModelAPI",
    baseQuery,
    endpoints: (builder) => ({

        // GET /vehicle/model
        // Optional: filter by makeId via query param
        getAllVehicleModels: builder.mutation({
            query: () => ({
                url: `/vehicle/model`,
                method: "GET",
                }),
            transformResponse: (response) => response,
        }),

        // POST /vehicle/model
        // Body: { name, makeId }
        createVehicleModel: builder.mutation({
            query: ({ body }) => ({
                url: `/vehicle/model`,
                method: "POST",
                body,
            }),
            transformResponse: (response) => response,
        }),

        // PUT /vehicle/model/{id}
        // Body: { name, makeId }
        updateVehicleModel: builder.mutation({
            query: ({ id, body }) => ({
                url: `/vehicle/model/${id}`,
                method: "PUT",
                body,
            }),
            transformResponse: (response) => response,
        }),

        // DELETE /vehicle/model/{id}
        deleteVehicleModel: builder.mutation({
            query: ({ id }) => ({
                url: `/vehicle/model/${id}`,
                method: "DELETE",
                body: {}
            }),
            transformResponse: (response) => response,
        }),

        // POST /vehicle/model/batch
        // Used for CSV bulk upload
        // Body: { models: [{ name, makeId }, ...] }
        batchCreateVehicleModels: builder.mutation({
            query: ({ body }) => ({
                url: `/vehicle/model/batch`,
                method: "POST",
                body,
            }),
            transformResponse: (response) => response,
        }),
        // ----------------------------------------------------------------
        // TEMPORARY — GET /vehicle/make
        // Remove this once colleague's make PR is merged and import from
        // vehicle-make-query instead.
        // ----------------------------------------------------------------
        getAllVehicleMakes: builder.mutation({
            query: () => ({
                url: `/vehicle/make`,
                method: "GET",
            }),
            transformResponse: (response) => response,
        }),
    }),
});

export const {
    useGetAllVehicleModelsMutation,
    useCreateVehicleModelMutation,
    useUpdateVehicleModelMutation,
    useDeleteVehicleModelMutation,
    useBatchCreateVehicleModelsMutation,
    useGetAllVehicleMakesMutation,  // TEMPORARY — remove after make PR merge
} = vehicleModelAPI;

export default vehicleModelAPI;